enum FeatureType {
  ADD_NODE = 'addNode',
  START_NODE = 'startNode',
  END_NODE = 'endeNode',
  UTTER_NODE = 'aussageNode',
  QUESTION_NODE = 'questionNode',
  DATE_CHOICE_NODE = 'dateChoiceNode',
  FAAS_CHOICE_NODE = 'faasChoiceNode',
  NUMBER_CHOICE_NODE = 'numberChoiceNode',
  REGEX_CHOICE_NODE = 'regexChoiceNode',
  TEXT_CHOICE_NODE = 'textChoiceNode',
  TOPIC_CHOICE_NODE = 'topicChoiceNode',
  EMAIL_ACTION_NODE = 'emailActionNode',
  PHONE_FORWARDING_ACTION_NODE = 'phoneForwardingActionNode',
  API_ACTION_NODE = 'apiActionNode',
  USER_INPUT_NODE = 'userInputNode',
  TIME_DECISION_NODE = 'timeDecisionNode',
}
export default FeatureType;
